module.exports = __webpack_public_path__ + "static/exo-v6-latin-regular-97a24ab2764d3410973c56f1ca10cf8b.woff";